import { useImpersonation } from '@/hooks/useImpersonation'
import { Eye, X } from 'lucide-react'
import { Button } from '@/components/ui/button'

export default function ImpersonationBanner() {
  const { isImpersonating, impersonatedOrg, stopImpersonation } = useImpersonation()

  if (!isImpersonating || !impersonatedOrg) return null

  const handleExit = () => {
    stopImpersonation()
    // Full page reload to clear all React component state from impersonated org
    window.location.href = '/admin/organizations'
  }

  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-amber-500 text-amber-950 px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium shadow-md">
      <Eye className="h-4 w-4 flex-shrink-0" />
      <span>
        Viewing as: <strong>{impersonatedOrg.orgName}</strong>
      </span>
      <Button
        variant="ghost"
        size="sm"
        onClick={handleExit}
        className="h-6 px-2 text-amber-950 hover:bg-amber-600 hover:text-amber-950"
      >
        <X className="h-3 w-3 mr-1" />
        Exit
      </Button>
    </div>
  )
}
